import type { SeriesData, SeriesRecord } from '@/components/Chart/types/chartData';
import type { TimeSeriesPoint } from '@/components/Chart/utils/buildChartLineSeries';

export const aggregateTimeSeriesPoints = ({
  series,
  field,
  decimalPlaces,
  seriesDataAggregator
}: {
  series: SeriesData;
  field: string;
  decimalPlaces: number;
  seriesDataAggregator: (tsData: SeriesRecord, decimalPlaces: number) => TimeSeriesPoint;
}) => {
  const fieldData = (series as Partial<SeriesData>)[field];
  return (
    fieldData?.map(tsData => {
      return {
        ...seriesDataAggregator(tsData, decimalPlaces)
      };
    }) ?? []
  );
};
